import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';

import WaitingRoomView from '../components/WaitingRoomView';
import withAsyncLifecycle from '../../core/hoc/async-lifecycle';
import translations from '../../core/i18n/translations';
import selectLocale from '../../core/selectors/i18n';
import { setLocale } from '../../core/actions/i18n';
import { selectHttpInfo, selectHttpIsError } from '../../core/selectors/http';
import { getIdFromUrl, getWaitingRoomParamsFromUrl } from '../utils/waiting-room-view-functions';
import { selectWaitingRoom } from '../selectors/waiting-rooms';
import { editWaitingRoom, getWaitingRoom } from '../actions/waiting-rooms';
import { GET_WAITING_ROOM_SESSION_POSITION_REQUEST_NAME, GET_WAITING_ROOMS_REQUEST_NAME } from '../api/config';

const WaitingRoomPreviewPage = () => {
    const dispatch = useDispatch();
    const waitingRoomId = getIdFromUrl();
    const waitingRoom = useSelector((state) => selectWaitingRoom(state, waitingRoomId));
    const locale = useSelector(selectLocale);
    const waitingRoomInfo = getWaitingRoomParamsFromUrl();

    const [initialLoad, setInitialLoad] = useState(false);

    useEffect(() => {
        if (waitingRoomInfo.language) {
            dispatch(setLocale(waitingRoomInfo.language));
        }

        dispatch(getWaitingRoom(waitingRoomId));
        setTimeout(() => setInitialLoad(true), 200);
    }, []);

    useEffect(() => {
        if (waitingRoom && waitingRoom.position !== waitingRoom.total - waitingRoom.sequence + 2) {
            dispatch(editWaitingRoom(waitingRoomId, ['position'], [waitingRoom.total - waitingRoom.sequence + 2]));
        }
    }, [waitingRoom]);

    const { isFetching, isError } = useSelector((state) => selectHttpInfo(state, GET_WAITING_ROOMS_REQUEST_NAME));
    const isErrorSession = useSelector((state) => (
        selectHttpIsError(state, GET_WAITING_ROOM_SESSION_POSITION_REQUEST_NAME)
    ));
    const WaitingRoomViewWithLifecycle = withAsyncLifecycle(WaitingRoomView, {
        isFetching: isFetching || !initialLoad,
        isError: isError || isErrorSession,
    });

    return (
        <IntlProvider locale={locale} defaultLocale={locale} messages={translations[locale]}>
            <WaitingRoomViewWithLifecycle waitingRoom={waitingRoom} />
        </IntlProvider>
    );
};

export default WaitingRoomPreviewPage;
